import CheckItem from 'Components/CheckItem/CheckItem'
import { evalCondition } from 'mailup-react-helpers'
import { Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'
import { messageState } from 'Pages/OverviewMessage/recoil/state/message'
import { modalCheckup } from 'Pages/OverviewMessage/recoil/state/modal'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

const BlockingCheck = () => {
  const intl = useIntl()
  const history = useHistory()

  const IsWhiteLabel = evalCondition('co:WHITELABEL')

  const { id: idMessage } = useRecoilValue(messageState)

  const {
    checkBlacklistResult,
    checkLiquidCode,
    checkAttachments,
    checkDynamicContents,
    checkSize,
    checkContent
  } = useRecoilValue(modalCheckup)

  const props = () => ({
    icon: 'ban',
    badge: intl.formatMessage({
      id: 'Load.EmailCheckUp.Block'
    })
  })

  const redirectEmailCheckUp = () => {
    const route = `/messages/email/${idMessage}/checkup/linkcheck`
    history.push(route)
  }

  return (
    <div className='c-blocking-issue'>
      {checkBlacklistResult.Action === 2 && (
        <CheckItem
          {...props()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.BlackListUrlError'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.BlackListUrlErrorDescrIntl'
            },
            {
              link: content => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key={content}
                  onClick={redirectEmailCheckUp}
                >
                  {content}
                </Link>
              )
            }
          )}
        />
      )}

      {!checkLiquidCode && (
        <CheckItem
          {...props()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.CheckLiquidCodeError'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.CheckLiquidCodeErrorDescr'
          })}
        />
      )}

      {!checkAttachments.Check && (
        <CheckItem
          {...props()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.AttachmentsError'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.AttachmentsErrorDescr'
          })}
        />
      )}

      {!checkDynamicContents.Check && (
        <CheckItem
          {...props()}
          title={intl.formatMessage({
            id: 'Load.Common.DynamicContent'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.DynamicContentsErrorDescr'
          })}
        />
      )}

      {!checkSize.Check && (
        <CheckItem
          {...props()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.EmptyMessageError'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.EmptyMessageErrorDescr'
          })}
        />
      )}

      {checkContent.Action === 2 && (
        <CheckItem
          {...props()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.SpamError'
          })}
          description={intl.formatMessage({
            id: IsWhiteLabel
              ? 'Load.EmailCheckUp.SpamErrorDescWhitelabel'
              : 'Load.EmailCheckUp.SpamErrorDesc'
          })}
        />
      )}
    </div>
  )
}

export default BlockingCheck
